import { Link, useRouter } from "@tanstack/react-router";
import { Button, Plate } from "@wilco/ui";
import { t } from "./i18n.ts";

export function ServerError() {
  const router = useRouter();
  return (
    <main className="page-center">
      <Plate cut="md" className="page-center-plate">
        <h1 className="page-title">{t("error.server.title")}</h1>
        <p className="w-muted">{t("error.server.lead")}</p>
        <Button variant="primary" onClick={() => void router.invalidate()}>
          {t("error.retry")}
        </Button>
      </Plate>
    </main>
  );
}

export function NotFound() {
  return (
    <main className="page-center">
      <Plate cut="md" className="page-center-plate">
        <p>{t("error.notFound")}</p>
        <Button asChild>
          <Link to="/">{t("section.desk")}</Link>
        </Button>
      </Plate>
    </main>
  );
}
